import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HttpClient } from '@angular/common/http';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ImportFileType } from 'src/app/models/ImportFileType';
import { ProcedureModel } from 'src/app/models/procedure';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { ImportFormat } from 'src/app/models/importFormat';

@Component({
  selector: 'app-procedures-nm-aixm51',
  templateUrl: './procedures-nm-aixm51.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class ProceduresNmAixm51Component implements OnInit {

  filesMap: Map<string, File>;

  fileTypes: string[] = ["Procedures", "Procedure Legs", "Designated Points", "Airports", "NavAids"];

  readonly importFormat: ImportFormat = ImportFormat.NM_AIXM_FORMAT;

  constructor(private bsModalRef: BsModalRef,
    private http: HttpClient,
    public endpointService: EndpointsService,
    private modalService: ModalControlService,
    private pointsService: PointsService,
    private uiBlock: UiBlockService) { }

  ngOnInit(): void {
    this.filesMap = new Map<string, File>();
  }

  cancelImport(): void {
    this.bsModalRef.hide();
  }

  saveFile(type: string, event: any): void {
    this.filesMap.delete(type);
    event.target.files.length > 0 ? this.filesMap.set(type, event.target.files[0]) : false;
  }


  startImport() {
    const filesToUpload: File[] = [];
    for (const type of this.fileTypes) {
      this.filesMap.has(type) ? filesToUpload.push(this.filesMap.get(type)) : false;
    }

    const formData: FormData = new FormData();
    for (const file of filesToUpload) {
      formData.append('file', file);
    }
    this.uiBlock.startBlock('Parsing NM AIXM 5.1 files...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileProcedures + '/' + ImportFileType.PROCEDURES_NM_AIXM51,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe((procedures: ProcedureModel[]) => {
        this.uiBlock.stopBlock();
        this.bsModalRef.hide();
        this.pointsService.importProceduresFromUpload(procedures);
      }, (error) => {
        this.uiBlock.stopBlock();
        this.pointsService.handleImportError(error, "NM AIXM 5.1");
      })
  }
}
